"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var url_1 = require("url");

var joinPath_1 = require("./joinPath");

var xhr_1 = require("./xhr");

exports.isBrowser = true;

function omit(obj, keys) {
  var result = {};

  for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (keys.includes(key)) continue;
    result[key] = obj[key];
  }

  return result;
}

function createRequest(baseUrl, agentOptions) {
  var _a = url_1.parse(baseUrl),
      auth = _a.auth,
      baseUrlParts = __rest(_a, ["auth"]);

  var options = omit(agentOptions, ["keepAlive", "keepAliveMsecs", "maxSockets"]);
  return function request(_ref, cb) {
    var method = _ref.method,
        url = _ref.url,
        headers = _ref.headers,
        body = _ref.body,
        timeout = _ref.timeout,
        expectBinary = _ref.expectBinary;
    var urlParts = Object.assign({}, baseUrlParts, {
      pathname: url.pathname ? baseUrlParts.pathname ? joinPath_1.joinPath(baseUrlParts.pathname, url.pathname) : url.pathname : baseUrlParts.pathname,
      search: url.search ? baseUrlParts.search ? "".concat(baseUrlParts.search, "&").concat(url.search.slice(1)) : url.search : baseUrlParts.search
    });

    if (!headers["authorization"]) {
      headers["authorization"] = "Basic ".concat(btoa(auth || "root:"));
    }

    var _callback = function callback(err, res) {
      _callback = function callback() {
        return undefined;
      };

      cb(err, res);
    };

    var req = xhr_1.default(Object.assign({
      responseType: expectBinary ? "blob" : "text"
    }, options, {
      url: url_1.format(urlParts),
      withCredentials: true,
      useXDR: true,
      body: body,
      method: method,
      headers: headers,
      timeout: timeout
    }), function (err, res) {
      if (!err) {
        if (!res.body) res.body = "";

        _callback(null, res);
      } else {
        var error = err;
        error.request = req;

        _callback(error);
      }
    });
  };
}

exports.createRequest = createRequest;